import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultEvents = {
    onSettingsChange: noop,
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop,
    onChange: noop,
    onClear: noop,
    onClose: noop,
    onExit: noop,
    onOpen: noop
};

function useGuestsEvents(props) {
    const {
        guestsEvents: propsEvents
    } = props;

    const {
        events
    } = useEvents(defaultEvents, propsEvents);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useGuestsEvents};
